"use client";

import { c as _c } from "react/compiler-runtime";
import { Download, FileText } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "../ui/button";
import { usePopup } from "@/providers/popup-provider";
type DownloadBrochureCardProps = {
  serviceId?: number | string;
};
export const DownloadBrochureCard = t0 => {
  const $ = _c(9);
  const {
    serviceId
  } = t0;
  const {
    openPopup
  } = usePopup();
  let t1;
  if ($[0] !== openPopup || $[1] !== serviceId) {
    t1 = () => {
      openPopup({
        type: "download-brochure",
        title: "Download Brochure",
        data: {
          serviceId
        }
      });
    };
    $[0] = openPopup;
    $[1] = serviceId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleDownload = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="from-primary/10 via-primary/5 absolute inset-0 bg-gradient-to-br to-transparent" />;
    t3 = <div className="bg-primary/10 pointer-events-none absolute -top-4 -right-4 h-16 w-16 rounded-full" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mb-2.5 flex items-center gap-2.5"><div className="bg-primary/15 ring-primary/20 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ring-1"><FileText className="text-primary" size={16} /></div><div><p className="text-foreground text-xs leading-tight font-semibold">Course Brochure</p><p className="text-muted-foreground text-[11px]">{"PDF \xB7 Curriculum, pricing & more"}</p></div></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Download size={13} className="transition-transform duration-200 group-hover:-translate-y-0.5" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== handleDownload) {
    t6 = <Card className="relative mt-3 overflow-hidden border-0 shadow-md">{t2}{t3}<CardContent className="relative py-3">{t4}<Button type="button" onClick={handleDownload} className="w-full">{t5}Download Brochure</Button></CardContent></Card>;
    $[7] = handleDownload;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};